import { withAuthenticationRequired } from '@tom-ui/utils'
import { useAdminStore } from '@tom-ui/admin'
import {
    CompanyAutocomplete,
    CompanyAutocompleteProps,
    ContainerDetailsCardByJourneyId,
    ImoClassAutoComplete,
    ImoClassAutoCompleteProps,
    LocationCodeAutoComplete,
    LocationCodeAutoCompleteProps,
    TransportSelection,
    TransportSelectionProps,
    usePlanningStore,
} from '@tom-ui/planning'
import { Yard } from '@tom-ui/yard'
import { observer } from 'mobx-react-lite'
import { useCallback } from 'react'

export const YardView = withAuthenticationRequired(
  observer(() => {
    const { containerJourneyItemStore } = usePlanningStore()
    const { tenantStore } = useAdminStore()

    const renderContainerDetailsByJourneyId = useCallback(
      (
        journeyId: number,
        highlight?: boolean,
        isReserved?: boolean,
        schemeBackgroundColor?: string,
      ) => {
        return (
          <ContainerDetailsCardByJourneyId
            journeyId={journeyId}
            highlight={highlight}
            isReserved={isReserved}
            schemeBackgroundColor={schemeBackgroundColor}
          />
        )
      },
      [],
    )

    const getJourneyByContainerIds = useCallback(
      (ids: number[]) => {
        return containerJourneyItemStore.fetch(ids)
      },
      [containerJourneyItemStore],
    )

    return (
      <Yard
        transportSelection={(props: TransportSelectionProps) => <TransportSelection {...props} />}
        renderContainerDetailsByJourneyId={renderContainerDetailsByJourneyId}
        getJourneyByContainerIds={getJourneyByContainerIds}
        companyAutoComplete={(props: CompanyAutocompleteProps) => (
          <CompanyAutocomplete {...props} />
        )}
        locationCodeAutoComplete={(props: LocationCodeAutoCompleteProps) => (
          <LocationCodeAutoComplete {...props} />
        )}
        warningThresholds={{
          allocationRule: tenantStore.allocationRuleWarningThreshold,
          block: tenantStore.blockWarningThreshold,
          yard: tenantStore.yardWarningThreshold,
        }}
        imoClassAutoComplete={(props: ImoClassAutoCompleteProps) => (
          <ImoClassAutoComplete {...props} />
        )}
      />
    )
  }),
)
